export default __webpack_public_path__ + "static/media/eventsentry.742b13ff.svg";